import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, unref as _unref, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1889d2f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-container" }
const _hoisted_2 = { class: "main-content" }
const _hoisted_3 = { class: "paper-header" }
const _hoisted_4 = { class: "item-container" }
const _hoisted_5 = { class: "item-row" }
const _hoisted_6 = { class: "cell-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "资源名称：", -1))
const _hoisted_8 = { class: "item-row" }
const _hoisted_9 = { class: "cell-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "更新时间：", -1))
const _hoisted_11 = { class: "item-row" }
const _hoisted_12 = {
  key: 1,
  class: "no-image-container"
}
const _hoisted_13 = { class: "side-container" }
const _hoisted_14 = { class: "sticky-container" }

import { computed, nextTick, onUnmounted, ref, watchEffect } from 'vue'
import { sanitizeHTML } from '@/hooks/utils/helper'
import { PaperConfig } from '@/types'
import DownFile from '@/components/paper/DownFile.vue'
import { format } from 'date-fns'

import MdEditor from 'md-editor-v3'
import 'md-editor-v3/lib/style.css'

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'PaperPreview',
  props: {
    item: {},
    searchKeyword: {}
  },
  setup(__props: any) {

const props = __props
const showImg = ref(true)
const searchKeyword = computed(() => props.searchKeyword)
const anchors = ref<{ id: string; text: string }[]>([])
const contentWithAnchors = ref('')
const currentPdfUrl = ref('')

// Define the observer at the top level of setup
const observer = new IntersectionObserver((entries, observer) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      const img = entry.target as HTMLImageElement
      const dataSrc = img.getAttribute('src_url')
      if (dataSrc) img.setAttribute('src', dataSrc)
      observer.unobserve(img)
    }
  })
}, {
  threshold: 0
})

onUnmounted(() => {
  observer.disconnect()
})

function observeImages () {
  nextTick(() => {
    const images = document.querySelectorAll('img[src_url]')
    images.forEach(img => {
      observer.observe(img)
    })
  })
}

const previewImages = computed(() => {
  const item = props.item
  return item && item.previewimages ? item.previewimages.split(',') : []
})

function formatDate (dateString: string): string {
  const date = new Date(dateString)
  return format(date, 'YYYY-MM-DD HH:mm:ss')
}

function removeHTMLTags (html: string): string {
  return html.replace(/<[^>]+>/g, '')
}

function scrollAnchor (anchorId: string) {
  const anchorElement = document.getElementById(anchorId)
  if (anchorElement) {
    const elementTop = anchorElement.getBoundingClientRect().top
    const currentScroll = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop
    const targetPosition = currentScroll + elementTop - 100

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    })

    // 等待滚动结束后可能需要额外的逻辑
    setTimeout(() => {
      console.log('Scroll finished')
    }, 1000)  // 可以调整延迟时间，确保滚动完成
  }
}

watchEffect(() => {
  const originalContent = showImg.value
    ? sanitizeHTML(props.item.papercontent)
    : sanitizeHTML(props.item.papercontent, true)
  const keyword = searchKeyword.value.trim()
  if (keyword) {
    let idCount = 1
    const headings: { id: string; text: string }[] = []
    const regex = new RegExp(`(${keyword})`, 'gi')
    let match
    const removedHtmlTagsContent = removeHTMLTags(originalContent)
    while ((match = regex.exec(removedHtmlTagsContent)) !== null) {
      const startIndex = match.index - 5
      const endIndex = Math.min(startIndex + keyword.length + 15, removedHtmlTagsContent.length)
      const text = removedHtmlTagsContent.substring(startIndex, endIndex)
      const id = `anchor-${idCount++}`
      headings.push({
        id,
        text
      })
    }
    idCount = 1
    const highlightedContent = originalContent.replace(regex, (match, keyword) => {
      const id = `anchor-${idCount++}`
      return `<span id="${id}" class="anchor highlighted">${keyword}</span>`
    })
    anchors.value = headings
    contentWithAnchors.value = highlightedContent
  } else {
    anchors.value = []
    contentWithAnchors.value = originalContent
  }
  observeImages()
})

return (_ctx: any,_cache: any) => {
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_card, { class: "header-item" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(_component_el_text, {
                    size: "large",
                    truncated: "",
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.item.papername), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode(_component_el_text, {
                    truncated: "",
                    type: "info"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(formatDate(_ctx.item.update_datetime)), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(DownFile, {
                  modelValue: currentPdfUrl.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentPdfUrl).value = $event)),
                  "is-primary": true,
                  item: _ctx.item
                }, null, 8, ["modelValue", "item"])
              ])
            ])
          ]),
          _: 1
        }),
        (previewImages.value[0])
          ? (_openBlock(), _createBlock(_component_el_image, {
              key: 0,
              "hide-on-click-modal": true,
              "initial-index": 0,
              "max-scale": 7,
              "min-scale": 0.2,
              "preview-src-list": previewImages.value,
              src: previewImages.value[0],
              "zoom-rate": 1.2,
              class: "image-preview",
              fit: "contain"
            }, null, 8, ["preview-src-list", "src"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_component_el_empty, { description: "暂无预览图片" })
            ]))
      ]),
      _createVNode(_unref(MdEditor), {
        modelValue: contentWithAnchors.value,
        "preview-only": ""
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(anchors.value, (anchor) => {
          return (_openBlock(), _createBlock(_component_el_tag, {
            key: anchor.id,
            onClick: ($event: any) => (scrollAnchor(anchor.id))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(anchor.id.replace('anchor-', '')) + " ... " + _toDisplayString(anchor.text) + " ... ", 1)
            ]),
            _: 2
          }, 1032, ["onClick"]))
        }), 128))
      ])
    ])
  ]))
}
}

})